<div class="captcha-popup">
  <div style="display: flex; align-items: center; gap: 8px">
    <p class="message">{{ data.message }}</p>
    <mat-icon
      matTooltip="Essa validação assegura a integridade da sua chave."
      matTooltipPosition="above"
      style="width: 16px; cursor: pointer"
      svgIcon="help"
    >
    </mat-icon>
  </div>

  <div id="widget" class="widget"></div>
</div>
